// extracted by mini-css-extract-plugin
export default {"Arrow":"OpenCloseArrow_Arrow__N9p0E","ArrowRotated":"OpenCloseArrow_ArrowRotated__qCb7k"};